import React from "react";
import { useSelector } from "react-redux";
import { Modal, Toggle, Button } from "@ts-digital/vrc";
import { FormattedMessage } from "react-intl";
import { Collapse } from "antd";
import useBusinessPerformancePermissionsList from "./useBusinessPerformancePermissionsList";
import "./style.css";

const { Panel } = Collapse;

const BusinessPerformanceModal = ({
  companyName,
  currentPermissions,
  settings,
  changeToggle,
  isBusinessPerformanceModalOpen,
  onCloseBusinessPerformanceModal,
  saveBusinessPerformancePermissions,
  changeInSettings,
  resetAll,
  isUser,
  userCompleteName,
}) => {
  const user = useSelector((state) => state.user);
  const userSettings = useSelector((state) => state.currentPermissions.permissionOtherUsers.otherUsersPermissions);
  const studioPermissions = currentPermissions.permissionClient.permissions;

  let collapsePanels = [];
  const studioPermissionsToIterate = studioPermissions.map((perm) => perm.permissions);

  if ((!isUser && currentPermissions.permissionClient && settings) || (isUser && userSettings && currentPermissions.permissionClient && settings)) {
    let permissionsGroup = isUser ? userSettings : settings;

    const permissionsListStructure = useBusinessPerformancePermissionsList(permissionsGroup, studioPermissionsToIterate, isUser);

    if (permissionsListStructure === null) {
      return null;
    }

    const permissionsListTemplate = permissionsListStructure.map((str) => {
      return str.listToIterate.map((perm, index) => {
        return (
          <div key={index}>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                marginBottom: "10px",
                justifyContent: "space-between",
                borderBottom: "1px solid #c9d9e8",
                height: "40px",
              }}
            >
              <div
                style={{
                  paddingRight: "20px",
                  display: "inline-block",
                  color: isUser && perm.companyPermission === false ? "rgb(157, 166, 173)" : "#000000",
                  fontWeight: "400",
                  width: "400px",
                  textOverflow: "ellipsis",
                  overflow: "hidden",
                  whiteSpace: "nowrap",
                }}
              >
                {user?.profile?.language === "es-ES" ? (
                  <FormattedMessage id={"permissions." + perm.functionLabel} defaultMessage={perm.functionLabel} />
                ) : (
                  perm.functionLabel
                )}
              </div>
              <div style={{ float: "right" }}>
                <Toggle
                  onChange={changeToggle.bind(this, str.index, index, perm.functionName, isUser ? true : false)}
                  checked={perm.isActive === true ? true : false}
                  backgroundStandardColor={"#c9d9e8"}
                  disabled={isUser && perm.companyPermission === false}
                />
              </div>
            </div>
          </div>
        );
      });
    });
    const collapsePanelsStructure = [
      {
        header: <FormattedMessage id="settings.businessPerformanceSettings.clientsTitle" />,
        templates: [permissionsListTemplate[0]],
      },
      {
        header: <FormattedMessage id="settings.businessPerformanceSettings.providersTitle" />,
        templates: [permissionsListTemplate[1]],
      },
      {
        header: <FormattedMessage id="settings.businessPerformanceSettings.portfolioTitle" />,
        templates: [permissionsListTemplate[2]],
      },
      {
        header: <FormattedMessage id="settings.businessPerformanceSettings.storeTitle" />,
        templates: [permissionsListTemplate[3]],
      },
    ];

    collapsePanels = collapsePanelsStructure.map((panel, index) => {
      return (
        <Panel header={panel.header} key={index} className="header-collapse-custom-panel-custom-panel">
          {panel.templates}
        </Panel>
      );
    });
  }

  const modalContentTitleUser = (
    <>
      <FormattedMessage id="settings.businessPerformanceModalUserTitle1" />
      <b>{userCompleteName}</b>
      <FormattedMessage id="settings.businessPerformanceModalUserTitle2" />
      <b>{companyName}</b>
    </>
  );
  const modalContentTitleItem = (
    <>
      <FormattedMessage id="settings.businessPerformanceModalContentTitle" /> <b>{companyName}</b>
    </>
  );

  return (
    <Modal
      visible={isBusinessPerformanceModalOpen}
      title={<FormattedMessage id="settings.businessPerformanceModalTitle" />}
      type="primary"
      onClose={onCloseBusinessPerformanceModal}
      footer={
        <div className="businessPerformanceModalButtonContainer">
          <Button className="bp-modal-reset-button" onClick={resetAll} disabled={!changeInSettings} type="submit" colorScheme="ghost">
            <FormattedMessage id="settings.resetPermissions" />
          </Button>
          <Button className="bp-modal-apply-button" onClick={saveBusinessPerformancePermissions} disabled={!changeInSettings}>
            <FormattedMessage id="settings.applyPermissions" />
          </Button>
        </div>
      }
    >
      <div className="business-performance-settings-modal">
        <h4 className="title"> {isUser ? modalContentTitleUser : modalContentTitleItem} </h4>
        <Collapse bordered={false}>{collapsePanels}</Collapse>
      </div>
    </Modal>
  );
};

export default BusinessPerformanceModal;
